import React, {useEffect} from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import AddQuestionForm from "../AddQuestionForm";

const styles = theme => ({
  dialog: {
    width: "476px"
  }
});

const initialData = {
  question: "",
  order: null,
  typeId: 1,
  isRequired: false
};

const AddQuestionModal = ({
  title,
  confirmButtonCaption,
  open,
  handleClose,
  onCreate,
  isCreating,
  createdObject,
  questionData,
  classes
}) => {
  const [data, setData] = React.useState(initialData);
  const [formData, updateFormData] = React.useState(null);

  useEffect(() => {
    if (questionData) {
      setData(questionData);
      updateFormData(questionData);
    }
  }, [questionData]);

  const onConfirm = () => {
    onCreate(formData);
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  React.useEffect(() => {
    if (createdObject && createdObject.success) {
      updateFormData(null);
      handleClose();
    }
  }, [createdObject]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>{title}</DialogTitle>
        <DialogContent>
          <AddQuestionForm
            onFormChange={updateFormData}
            disabled={isCreating}
            initialData={data}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isCreating}
            disabled={isCreating || !formData}
            onClick={() => onConfirm()}
            color="green"
          >
            {confirmButtonCaption}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(withRouter(AddQuestionModal));
